// ============================================================
// SevenStars SmartCare Passport V3 — Production App Router
// Backend: Supabase
// ============================================================
import React, { useState, useEffect } from 'react';
import { seedDemoData, passportStore } from './store/data';
import UnitPassport from './pages/UnitPassport';
import AdminDashboard from './pages/AdminDashboard';
import TechnicianView from './pages/TechnicianView';
import LandingPage from './pages/LandingPage';

export default function App() {
  const [view, setView] = useState('loading');
  const [unitToken, setUnitToken] = useState(null);
  const [seedStatus, setSeedStatus] = useState('seeding'); // seeding | done | error

  useEffect(() => {
    const init = async () => {
      try {
        // Seed database if empty (first time only)
        await seedDemoData();
        setSeedStatus('done');
      } catch (err) {
        console.error('Seed error:', err);
        setSeedStatus('error');
      }

      // Check URL for unit token — primary QR access
      const params = new URLSearchParams(window.location.search);
      const token = params.get('unit');
      if (token) {
        const passport = await passportStore.getByToken(token);
        if (passport) {
          setUnitToken(token);
          setView('unit');
          return;
        }
      }
      setView('landing');
    };
    init();
  }, []);

  const handleAdminLogin = (password) => {
    if (password === 'SS@Admin2026') { setView('admin'); return true; }
    return false;
  };

  const handleTechLogin = (password) => {
    if (password === 'SS@Tech2026') { setView('tech'); return true; }
    return false;
  };

  const handleUnitAccess = (token) => {
    setUnitToken(token);
    setView('unit');
    window.history.pushState({}, '', `?unit=${token}`);
  };

  const handleBack = () => {
    setView('landing');
    setUnitToken(null);
    window.history.pushState({}, '', window.location.pathname);
  };

  if (view === 'loading') {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4"
        style={{ background: 'linear-gradient(135deg, #081d31, #1B4F72)' }}>
        <div className="w-14 h-14 border-4 border-white/20 border-t-white rounded-full animate-spin" />
        <p className="text-white/60 text-sm">
          {seedStatus === 'seeding' ? 'Setting up your passport system…' : 'Loading…'}
        </p>
      </div>
    );
  }

  if (view === 'unit') return <UnitPassport token={unitToken} onBack={handleBack} />;
  if (view === 'admin') return <AdminDashboard onBack={() => setView('landing')} onUnitAccess={handleUnitAccess} />;
  if (view === 'tech') return <TechnicianView onBack={() => setView('landing')} />;

  return (
    <LandingPage
      onAdminLogin={handleAdminLogin}
      onTechLogin={handleTechLogin}
      onUnitAccess={handleUnitAccess}
    />
  );
}
